import { render, staticRenderFns } from "./barter.vue?vue&type=template&id=da079a0a&scoped=true&"
import script from "./barter.vue?vue&type=script&lang=js&"
export * from "./barter.vue?vue&type=script&lang=js&"
import style0 from "./barter.vue?vue&type=style&index=0&id=da079a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da079a0a",
  null
  
)

export default component.exports